import { createSelector } from 'reselect';

import { selectIsDealDepositMadeState } from 'domains/account/actions/checkDealDeposit';
import { selectIsFreemium } from 'modules/accountStatus/store/selectors';
import { selectIsPAYGDepositMadeState } from 'domains/account/actions/checkPAYGDeposit';
import { selectIsPersonalAccount } from 'modules/account/store/selectors';

import { selectReferrer } from '../actions/fetchReferrer';

export const selectIsAccountEligible = createSelector(
  selectIsFreemium,
  selectIsPersonalAccount,
  (isFreemium, isPersonalAccount) => isPersonalAccount && isFreemium,
);

// Combine both deposit-state slices into a single input selector so the
// selectHasReferralBonus result function stays within max-params (3) — a
// 4th param needed an inline eslint-disable that prettier kept relocating.
const selectDepositMadeState = createSelector(
  selectIsPAYGDepositMadeState,
  selectIsDealDepositMadeState,
  (payg, deal) => ({ payg, deal }),
);

export const selectHasReferralBonus = createSelector(
  selectReferrer,
  selectIsPersonalAccount,
  selectDepositMadeState,
  (referrer, isPersonalAccount, { deal, payg }) => {
    const hasReferrer = Boolean(referrer);

    if (!hasReferrer || !isPersonalAccount) {
      return false;
    }

    const isUninitialized = payg.isUninitialized || deal.isUninitialized;
    const isLoading = payg.isLoading || deal.isLoading;
    const hasData =
      typeof payg.data !== 'undefined' && typeof deal.data !== 'undefined';

    const isLoadingInitially = !hasData && isLoading;

    if (isUninitialized || isLoadingInitially) {
      return false;
    }

    const isDepositMade = payg.data || deal.data;

    return hasReferrer && !isDepositMade;
  },
);
